import React from 'react';
import { connect } from 'react-redux';

import { includeFixedDigits } from '../../../../../../util/utils';
import tagular from '../../../../../../util/tagular';
import { eventByType } from '../../../../../../api/eventsApi';
import { receiveComparison, removeComparison } from '../../../../../../actions/compareActions';
import { openModal } from '../../../../../../actions/modalActions';
import { elementViewed } from '../../../../../../actions/elementsViewedActions';

import plus_gray from '../../../../../../assets/plus-thick-gray.svg';
import plus_magenta from '../../../../../../assets/plus-thick-magenta.svg';
import check from '../../../../../../assets/check-small.svg';

class DietCardContent extends React.Component {
    constructor(props) {
        super(props);

        this.handleCompareClick = this.handleCompareClick.bind(this);
        this.handleFullReviewClick = this.handleFullReviewClick.bind(this);
        this.handleElementViewed = this.handleElementViewed.bind(this);
        this.determineSelectionState = this.determineSelectionState.bind(this);
    }

    componentDidUpdate(prevProps) {
        const { inViewport, elementsViewed, result } = this.props;

        if (
            inViewport !== prevProps.inViewport &&
            inViewport &&
            !elementsViewed.includes(result.title)
        ) {
            this.handleElementViewed();
        }
    }

    itemIsSelected(array, key) {
        const allKeys = array.map(obj => Object.keys(obj)[0]);
        return allKeys.includes(key);
    }

    determineSelectionState() {
        if (this.itemIsSelected(this.props.compareItems, this.props.result.title)) {
            return 'selected';
        }
        return 'unselected';
    }

    handleCompareClick(e) {
        const {
            compareItems,
            result,
            assessment,
            distpatchReceiveComparison,
            distpatchRemoveComparison,
            distpatchOpenModal,
            inlineParentMetadata
        } = this.props;

        if (this.itemIsSelected(compareItems, result.title)) {
            return distpatchRemoveComparison(result.title);
        }

        tagular.sendElementClickedEvent(e, {
            assessmentName: assessment.internalName,
            name: result.title,
            action: 'OPEN'
        });

        if (compareItems.length === 0) {
            eventByType(`compare-${result.title.replace(' ', '-')}`, assessment.id, {
                inlineParentMetadata
            });
            return distpatchReceiveComparison(result);
        }
        distpatchReceiveComparison(result);
        eventByType('compare-diets', assessment.id, { inlineParentMetadata });
        return distpatchOpenModal('comparison');
    }

    handleFullReviewClick(e) {
        const { assessment, result, inlineParentMetadata } = this.props;

        eventByType('see-full-review', assessment.id, { inlineParentMetadata });
        tagular.sendElementClickedEvent(e, {
            assessmentName: assessment.internalName,
            name: result.title,
            outboundUrl: result.url,
            action: 'INTERNALLINK'
        });
    }

    handleElementViewed() {
        const { assessment, result } = this.props;

        this.props.distpatchElementViewed(result.title);
        tagular.sendElementViewedEvent({
            assessmentName: assessment.internalName,
            name: result.title,
            elementType: 'BUTTON',
            text: 'SEE FULL REVIEW'
        });
    }

    render() {
        const { result, forwardedRef } = this.props;

        return (
            <div className="result-card" ref={forwardedRef}>
                <div className="img-container">
                    <img className="result-img" src={result.imageUrl} alt="" />
                </div>

                <div className="result-card-content">
                    <h1 className="title">{result.title}</h1>

                    <div className="scores">
                        <div className="overall">
                            <p className="name">Overall Rating</p>
                            <p className="score">{includeFixedDigits(result.overallRating, 1)}</p>
                        </div>
                        <div className="whole-body">
                            <p className="name">Weight Change</p>
                            <p className="score">{includeFixedDigits(result.weightVariation, 1)}</p>
                        </div>
                        <div className="habits">
                            <p className="name">Healthy Eating Habits</p>
                            <p className="score">
                                {includeFixedDigits(result.healthyEatingHabits, 1)}
                            </p>
                        </div>
                    </div>

                    <div className="description">{result.briefDescription}</div>

                    <div className="options">
                        <a
                            href={result.url}
                            className="review button"
                            target="_blank"
                            onClick={e => this.handleFullReviewClick(e)}
                        >
                            SEE FULL REVIEW
                        </a>
                        <button
                            className="compare button"
                            id={this.determineSelectionState()}
                            onClick={e => this.handleCompareClick(e)}
                        >
                            <img className="plus gray icon" src={plus_gray} />
                            <img className="plus magenta icon" src={plus_magenta} />
                            <img className="check icon" src={check} />
                            COMPARE
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        assessment: state.app.assessment,
        filteredResults: state.session.filteredResults,
        selectedFilters: state.session.selectedFilters.inResults,
        compareItems: state.compare,
        inlineParentMetadata: state.inline.parentMetadata,
        elementsViewed: state.session.elementsViewed
    };
};

const mapDispatchToProps = dispatch => {
    return {
        distpatchReceiveComparison: result => dispatch(receiveComparison(result)),
        distpatchRemoveComparison: resultTitle => dispatch(removeComparison(resultTitle)),
        distpatchOpenModal: modal => dispatch(openModal(modal)),
        distpatchElementViewed: element => dispatch(elementViewed(element))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DietCardContent);
